import React from 'react';
import { Check } from 'lucide-react';
import { useCountdown } from '../useCountdown';
import { Cta, Heading, Reveal, Section } from './primitives';

const VALUE_STACK = [
  'Personalized assessment',
  'Personalized daily rituals',
  'Morning Intentions',
  'Shadow Work',
  'Vision Quest',
  'Night Reflections',
  'Affirmations + gratitude',
  'Reflective journaling',
  'AI personalization',
  'Rituals guided in your own voice',
  'Short 5–15 minute practices',
];
const HIGHLIGHT = 'Rituals guided in your own voice';

export default function Offer({ variant }) {
  const { label, expired } = useCountdown(variant.offer.timer);

  return (
    <Section id="offer" className="bg-[#111111]/40">
      {variant.offer.timer && (
        <Reveal className="mb-12 text-center">
          <div className="glass-card mx-auto inline-flex flex-col items-center px-8 py-5">
            <span className="text-[10px] uppercase tracking-[0.28em] text-white/50">
              Limited access · offer expires in
            </span>
            <span
              className={`mt-2 font-jakarta text-4xl font-light tabular-nums ${expired ? 'text-[#e5867a]' : 'text-[#F5A623]'}`}
              aria-live="polite"
            >
              {label}
            </span>
            <span className="mt-2 text-xs text-white/50">
              {expired
                ? 'Offer may have expired — claim your spot now'
                : 'Claim your personalized practice before this offer closes'}
            </span>
          </div>
        </Reveal>
      )}

      <Reveal className="text-center">
        <Heading
          lines={['Your personalized system', 'for training your inner voice.']}
          className="text-3xl md:text-5xl"
        />
      </Reveal>

      <Reveal className="mt-12">
        <ul className="glass-card mx-auto grid max-w-xl gap-x-6 gap-y-3 p-7 sm:grid-cols-2">
          {VALUE_STACK.map((item) => (
            <li
              key={item}
              className={`flex items-start gap-3 text-sm ${item === HIGHLIGHT ? 'font-medium text-[#F5A623] sm:col-span-2' : 'text-white/80'}`}
            >
              <Check size={16} className="mt-0.5 shrink-0 text-[#F5A623]" />
              {item}
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal className="mt-10 text-center">
        <p className="font-jakarta text-lg text-white">Not another library of generic meditations.</p>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/60">
          DepthMe learns about you and creates a practice around your goals, patterns and reflections.
        </p>
        <div className="mt-8">
          <Cta variant={variant}>Start with DepthMe</Cta>
        </div>
      </Reveal>
    </Section>
  );
}
